export default __webpack_public_path__ + "static/media/Toggle-active.11540d34.svg";